import { render, staticRenderFns } from "./DisplayIdProofFrontBack.vue?vue&type=template&id=44b44709"
import script from "./DisplayIdProofFrontBack.vue?vue&type=script&lang=js"
export * from "./DisplayIdProofFrontBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports